import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { VariableLocalSesionService } from 'new-sysman-ui';

export const AuthGuard: CanActivateFn = () => {
  const variableSesion = inject(VariableLocalSesionService);
  const router = inject(Router);

  if (variableSesion.getData('AutenticacionOK') === 'true') {
    return true;
  } else {
    return router.parseUrl('/');
  }
};
